var panteraRegionsMap = function (options) {
    this.init(options);
};

panteraRegionsMap.prototype = {
    init: function (options) {
        this.regionsMap = null;
        this.mapCenter = null;
        this.regionsMapBounds = new google.maps.LatLngBounds();
        this.numRows = null;
        this.FTresponse = null;
        this.polyLayers = [];
        this.mapCenter = null;
        this.stateFusionLayer = null;
        this.cityFusionLayer = null;
        this.fusionLayerIndex = 0;
        this.zipFusionLayers = [];
        this.queryCharLimit = 551;
        this.thisZipString = '';
        this.zipSendCounter = 0;
        this.zipGetCounter = 0;
        this.zipCirclesLayers = [];
        this.regionsGrid = null;
        this.regionsToolbar = null;
        this.stateInput = null;
        this.countyInput = null;
        this.cityInput = null;
        this.zipInput = null;
        this.radiusInput = null;
        this.oldCountrySelect = '';
        this.oldStateSelect = '';
        this.oldCountySelect = '';
        this.newRowCounter = 0;
        this.stateRegions = [];
        this.zipRegions = [];
        this.zipStateCountyGrid = null;
        this.zipStateCountyDlg = null;
        this.zipStateCountyCheckedCount = 0;
        this.zipStateCountyFound = false;
        this.options = options;
        this.allStatesStr = 'AK,AL,AR,AS,AZ,CA,CO,CT,DC,DE,FL,GA,GU,HI,IA,ID,IL,IN,KS,KY,LA,MA,MD,ME,MH,MI,MN,MO,MP,MS,MT,NC,ND,NE,NH,NJ,NM,NV,NY,OH,OK,OR,PA,PR,PW,RI,SC,SD,TN,TX,UT,VA,VI,VT,WA,WI,WV,WY';
        this.allStatesArr = this.allStatesStr.split(',');
        this.conusStatesStr = 'AL,AZ,AR,CA,CO,CT,DE,FL,GA,ID,IL,IN,IA,KS,KY,LA,ME,MD,MA,MI,MN,MS,MO,MT,NE,NV,NH,NJ,NM,NY,NC,ND,OH,OK,OR,PA,RI,SC,SD,TN,TX,UT,VT,VA,WA,WV,WI,WY';
        this.conusStatesArr = this.conusStatesStr.split(',');
        this.allProvinceStr = 'AB,BC,MB,NB,NL,NT,NS,ON,PE,QC,SK,YT';
        this.allProvinceArray = this.allProvinceStr.split(',');
        this.validNumChars = '0123456789';
        this.unsavedRegions = [];
        this.unsavedDeletedRegions = [];
        if (!this.options.$el) {
            return;
        }
        this.options.$el.html(jQuery("#RegionsMap-Master-TMPL").render());

        jQuery('#regionsGridContainer').show();

        if (this.options.isSubcontractorView)
            jQuery('#regionsSubcontractorNote').show();

        if (this.options.isReadOnly) {
            jQuery('#regionsAddTable').hide();
        }

        jQuery('.regionsRow').show();
        jQuery('.addRegionsButton').button();
        jQuery('#addRegionRadiusSlider').slider({
            min: 1,
            max: 300,
            slide: function (event, ui) {
                jQuery('#addRegionRadius').val(ui.value);
                jQuery('#addRegionRadius').trigger('change');
            }
        });
        jQuery('#addRegionRadiusSlider').slider('option', 'value', '50');

        jQuery('#addRegionZip, #addRegionRadius').on('keyup change', jQuery.proxy(function () {
            jQuery('#addRegionRadiusSlider').slider('option', 'value', this.radiusInput.val());
            if (parseInt(this.radiusInput.val()) > 300) {
                this.radiusInput.val(300);
            }
            if (this.zipInput.val().length >= 5 && parseInt(this.radiusInput.val()) > 0) {
                jQuery('#addZipRegionsButton').button('enable');
            } else {
                jQuery('#addZipRegionsButton').button('disable');
            }
        }, this));

        this.InitRegionsMap();

        //attach some functions to window to support old events that are included in markup
        window.RefreshRegionSelections = this.RefreshRegionSelections.bind(this);
        window.GetPrequalRegionDropDownData = this.GetPrequalRegionDropDownData.bind(this);
        window.AddRegion = this.AddRegion.bind(this);
        window.AddRegionHelper = this.AddRegionHelper.bind(this);
        window.DeleteRegion = this.DeleteRegion.bind(this);
    },
    InitRegionsMap: function () {
        if (!google.visualization) {
            google.charts.load("current", {
                packages: ['geomap', 'table']
            });
            google.charts.setOnLoadCallback(this.drawRegionsMap.bind(this));
        }
        else {
            this.drawRegionsMap();
        }
    },
    showInfoDialog: function(titleText, message, iconClass, context) {

            if (iconClass)
                jQuery('#dialog-message-icon-rm').addClass(iconClass);
            else
                jQuery('#dialog-message-icon-rm').addClass('ui-icon-info');

            jQuery('#dialog-message-context-rm').val(context);

            jQuery('#dlg-message-span-rm').html(message);
            var buttonList = {
                Ok: function () {
                    $(this).dialog("close");
                }
            },
                self = this;
            if (context == 'delete-contact-regions') {
                buttonList = {
                    Ok: function () {
                        var context = jQuery('#dialog-message-context-rm').val();
                        if (context == 'delete-contact-regions') {
                            self.DeleteAllRegions();
                        }
                        $(this).dialog("close");
                    },
                    Cancel: function () {
                        $(this).dialog("close");
                    }
                };
            }
            else if (context == 'no-buttons') {
                buttonList = {};
            }

            var dlg = jQuery("#dialog-message-rm").dialog({
                modal: true,
                title: titleText,
                resizable: false,
                buttons: buttonList
            });
            dlg.parent().appendTo($("Form[name='Form']"));

            return jQuery("#dialog-message-rm");
    },
    drawRegionsMap: function () {
        this.mapCenter = new google.maps.LatLng(38.6159, -100.7456);
        window.mapCenter = this.mapCenter;
        var mapOptions = {
            zoom: 3,
            center: this.mapCenter,
            mapTypeId: google.maps.MapTypeId.ROADMAP
        };
        this.InitRegionsGrid();
        this.regionsMap = new google.maps.Map(document.getElementById("map-canvas"), mapOptions);
        window.regionsMap = this.regionsMap;
    },
    resizeMap: function () {
        google.maps.event.trigger(this.regionsMap, 'resize');
        this.regionsMap.setCenter(this.mapCenter);
        this.CreateMapFusionLayersHelper();
    },
    InitRegionsGrid: function () {
        this.stateInput = jQuery('#addRegionState');
        this.countyInput = jQuery('#addRegionCounty');
        this.cityInput = jQuery('#addRegionCity');
        this.zipInput = jQuery('#addRegionZip');
        this.radiusInput = jQuery('#addRegionRadius');
        this.regionsToolbar = new dhtmlXToolbarObject("regionsToolbar");
        this.regionsToolbar.setSkin("dhx_web");
        this.regionsToolbar.setIconsPath("/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxToolbar/imgs/");
        if (!this.options.isReadOnly) {
            if (!this.options.isSubcontractorView) {
                this.regionsToolbar.addButton('add', 0, 'Add Nationwide Regions', "new.gif", "new_dis.gif");
            }

            this.regionsToolbar.addButton('delete', 4, 'Delete All Regions', "Delete.png", "DeleteD.png");
            this.regionsToolbar.attachEvent("onClick", jQuery.proxy(function (id) {
                switch (id) {
                    case 'add':
                        this.AddNationwideRegions();
                        break;
                    case 'delete':
                        this.showInfoDialog('Delete Confirmation', 'Are you sure you want to delete all regions for this Contact?', 'ui-icon-alert', 'delete-contact-regions');
                        break;
                }
            }, this));
        }

        
        this.regionsGrid = new dhtmlXGridObject('regionsGrid');
        this.regionsGrid.setImagePath('/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxgrid/imgs/');
        this.regionsGrid.setSkin(pjqGridTheme);
        this.regionsGrid.enableAutoHeight(true);
        this.regionsGrid.enablePaging(true, 10, 3, "regionsGridPaging", true);
        this.regionsGrid.setPagingSkin("toolbar", "dhx_web");
        this.regionsGrid.setDragBehavior('complex');
        this.regionsGrid.setDelimiter('|');
        var gridXMLPath = "/DesktopModules/PJQRegistration/GetRegistrationGrid.aspx?sessionId=" + this.options.sessionId + "&contId=" + (this.options.contactId ? this.options.contactId.toString() : "") + "&gridId=Regions";
        if (this.options.gridXMLPath != null)
            gridXMLPath = this.options.gridXMLPath;
        this.regionsGrid.loadXML(gridXMLPath);
        this.regionsGrid.init();
        this.regionsGrid.attachEvent("onXLE", jQuery.proxy(function (grid_obj, count) {
            this.RefreshRegionSelections('state');
            this.CreateMapFusionLayersHelper();
            isRegionsInit = true;
            if (typeof CalculateSectionCompletion === 'function')
                CalculateSectionCompletion();

            jQuery('#regionsGrid').css('width', '100%');
            this.regionsGrid.setSizes();
        }, this));
        window.regionsGrid = this.regionsGrid;
    },
    CreateMapFusionLayersHelper: function () {
        this.regionsMapBounds = new google.maps.LatLngBounds();

        if (typeof CreateOverlay === 'function')
            CreateOverlay('regionsmap');

        var isState = false;
        if (this.stateFusionLayer != null) {
            this.stateFusionLayer.setMap(null);
        }
        if (this.zipCirclesLayers != null) {
            for (var zc = 0; zc < this.zipCirclesLayers.length; zc++) {
                this.zipCirclesLayers[zc].setMap(null);
            }
        }
        if (this.zipFusionLayers != null) {
            for (var zf = 0; zf < this.zipFusionLayers.length; zf++) {
                this.zipFusionLayers[zf].setMap(null);
            }
        }
        zipCounter = 0;
        for (var sfl = 0; sfl < this.regionsGrid.getRowsNum() ; sfl++) {
            var thisCity = 'null';
            var thisCounty = this.regionsGrid.cells2(sfl, 0).getValue();
            var thisState = this.regionsGrid.cells2(sfl, 1).getValue();
            var thisZip = this.regionsGrid.cells2(sfl, 2).getValue();
            var thisRadius = this.regionsGrid.cells2(sfl, 3).getValue();

            if (thisCounty != 'N/A' && thisCounty != 'All') {
                this.zipSendCounter++;
            }
        }

        for (var pli = 0; pli < this.polyLayers.length; pli++) {
            this.polyLayers[pli].setMap(null);
        }
        this.polyLayers = [];

        var usStatesArr = [];
        var caStatesArr = [];
        var usStatesStr = '';
        var caStatesStr = '';
        for (var sfl = 0; sfl < this.regionsGrid.getRowsNum() ; sfl++) {
            var thisCity = 'null';
            var thisCounty = this.regionsGrid.cells2(sfl, 0).getValue();
            var thisState = this.regionsGrid.cells2(sfl, 1).getValue();
            var thisZip = this.regionsGrid.cells2(sfl, 2).getValue();
            var thisRadius = this.regionsGrid.cells2(sfl, 3).getValue();

            if (thisCounty == 'All') {
                isState = true;
                if (this.allStatesArr.indexOf(thisState) != -1)
                    usStatesStr += "'" + thisState + "',";
                else if (this.allProvinceArray.indexOf(thisState) != -1)
                    caStatesStr += "'" + thisState + "',";
            } else if ((thisCounty != 'N/A' && thisCounty != 'All')) {
                PanteraScript.PanteraScriptService.GetZipCodeInfoByStateCountyCity(thisState, thisCounty, "", this.CreateMapZipFusionLayersHelper.bind(this), onScriptError);
            } else if (thisZip.length != 1) {
                PanteraScript.PanteraScriptService.GetLatLongInfoByZipCode(thisZip, parseInt(thisRadius), this.CreateMapZipCirclesLayers.bind(this), onScriptError);
            }
        }
        if (isState) {
            if (usStatesStr.length > 0) {
                usStatesStr = usStatesStr.substring(0, usStatesStr.length - 1);
                this.CreateMapStateFusionLayers(usStatesStr, 'us');
            }
            if (caStatesStr.length > 0) {
                caStatesStr = caStatesStr.substring(0, caStatesStr.length - 1);
                this.CreateMapStateFusionLayers(caStatesStr, 'ca');
            }
        }

        if (typeof DestroyOverlay === 'function')
            DestroyOverlay();
    },
    CreateMapStateFusionLayers: function (stateStringF, country) {
        var fusionDoc = '';
        var fusionRow = '';
        var fusionSelect = '';
        if (stateStringF.length != 0) {
            if (country.toLowerCase() == 'us') {
                fusionDoc = '17aT9Ud-YnGiXdXEJUyycH2ocUqreOeKGbzCkUw';
            } else if (country.toLowerCase() == 'ca') {
                fusionDoc = '1NJTA4fm4bf8zKGnjhhTP2vjLGn7nOri3ImKqLMNW';
            }
            var stateQuery;
            var boundsQueryText;
            var boundsQuery;

            if (stateStringF == this.allStatesStr) {
                this.stateInput.attr('disabled', true);
                jQuery('#addStateRegionsButton').button('disable');
                boundsQueryText = encodeURIComponent("SELECT 'geometry' FROM " + fusionDoc);

            } else {
                this.stateInput.attr('disabled', false);
                jQuery('#addStateRegionsButton').button('enable');
                if (stateStringF.indexOf(',') != -1) {
                    stateQuery = "'id' in (" + stateStringF + ')';
                    boundsQueryText = encodeURIComponent("SELECT 'geometry' FROM " + fusionDoc + " WHERE " + stateQuery);

                    stateQuery = 'id in (' + stateStringF + ')';
                } else {
                    stateQuery = "'id' = " + stateStringF;
                    boundsQueryText = encodeURIComponent("SELECT 'geometry' FROM " + fusionDoc + " WHERE " + stateQuery);

                    stateQuery = 'id = ' + stateStringF;
                }
            }
            boundsQuery = new google.visualization.Query( window.location.protocol + '//www.google.com/fusiontables/gvizdata?tq=' + boundsQueryText);
            boundsQuery.send(this.addToBounds.bind(this));
        }
    },
    addToBounds: function (response) {
        if (!response) {
            alert('no response');
            return;
        }
        if (response.isError()) {
            alert('Error in query: ' + response.getMessage() + ' ' + response.getDetailedMessage());
            return;
        }
        this.FTresponse = response;

        this.numRows = response.getDataTable().getNumberOfRows();

        for (i = 0; i < this.numRows; i++) {
            var kml = this.FTresponse.getDataTable().getValue(i, 0);
            var geoXml = new geoXML3.parser({
                map: this.regionsMap,
                suppressInfoWindows: true,
                zoom: false
            });
            geoXml.parseKmlString("<Placemark>" + kml + "</Placemark>", geoXml.docs);
            if (geoXml.docs && geoXml.docs.length > 0 && geoXml.docs[0].gpolygons && geoXml.docs[0].gpolygons.length > 0) {

                geoXml.docs[0].gpolygons[0].setOptions({
                    fillColor: "#FF0000",
                    strokeColor: "#FF0000",
                    strokeOpacity: 0.8,
                    fillOpacity: 0.25
                });

                var topLeftBounds = new google.maps.LatLng(geoXml.docs[0].gpolygons[0].bounds.f.b, geoXml.docs[0].gpolygons[0].bounds.b.b);
                var botRightBounds = new google.maps.LatLng(geoXml.docs[0].gpolygons[0].bounds.f.f, geoXml.docs[0].gpolygons[0].bounds.b.f);
                this.regionsMapBounds.extend(topLeftBounds);
                this.regionsMapBounds.extend(botRightBounds);

                var polyLayersIndex = this.polyLayers.length;
                this.polyLayers[polyLayersIndex] = geoXml.docs[0].gpolygons[0];
            }
        }
        this.regionsMap.fitBounds(this.regionsMapBounds);
    },
    CreateMapZipFusionLayersHelper: function (zipString) {
        zipCounter++;
        if (this.thisZipString.length == 0)
            this.thisZipString = zipString;
        else if (zipString.length > 0)
            this.thisZipString += (',' + zipString);
        if (this.zipSendCounter == zipCounter) {
            this.CreateMapZipFusionLayers(this.thisZipString);
            this.thisZipString = '';
            this.zipSendCounter = 0;
            this.zipGetCounter = 0;
        }
    },
    CreateMapZipFusionLayers: function (zipStringF) {
        if (zipStringF.length != 0) {
            var thisZipQuery = '';
            var nextZipQuery = '';
            if (zipStringF.length > this.queryCharLimit) {
                nextZipQuery = zipStringF.substr(this.queryCharLimit + 1, zipStringF.length);
                thisZipQuery = zipStringF.substr(0, this.queryCharLimit);
            } else
                thisZipQuery = zipStringF;

            if (thisZipQuery.substr(-1) == ',')
                thisZipQuery = thisZipQuery.substr(0, thisZipQuery.length - 1);

            var docId = '';
            var zipCol = '';
            docId = '1Lae-86jeUDLmA6-8APDDqazlTOy1GsTXh28DAkw';
            zipCol = 'ZIP';
            /*
			if (us) {
				docId = '1Lae-86jeUDLmA6-8APDDqazlTOy1GsTXh28DAkw';
				zipCol = 'ZIP';
			} else {
				docId = '1H_cl-oyeG4FDwqJUTeI_aGKmmkJdPDzRNccp96M';
				zipCol = 'PostalCode';
			}
			*/

            var zipQuery = '';
            var boundsQueryText;
            var boundsQuery;

            if (thisZipQuery.indexOf(',') != -1) {
                zipQuery = "'" + zipCol + "'" + ' in (' + thisZipQuery + ')';
                boundsQueryText = encodeURIComponent("SELECT 'geometry' FROM " + docId + " WHERE " + zipQuery);

                zipQuery = zipCol + ' in (' + thisZipQuery + ')';
            } else {
                zipQuery = "'" + zipCol + "'" + ' = ' + thisZipQuery;
                boundsQueryText = encodeURIComponent("SELECT 'geometry' FROM " + docId + " WHERE " + zipQuery);

                zipQuery = zipCol + ' = ' + thisZipQuery;
            }
            this.fusionLayerIndex++;

            boundsQuery = new google.visualization.Query(window.location.protocol + '//www.google.com/fusiontables/gvizdata?tq=' + boundsQueryText);
            boundsQuery.send(this.addToBounds.bind(this));

            if (nextZipQuery.length > 0)
                this.CreateMapZipFusionLayers(nextZipQuery);
        }
    },
    CreateMapZipCirclesLayers: function (response) {
        var llResult = jQuery.parseJSON(response);
        var circleOpts = {
            strokeColor: '#FF0000',
            strokeOpacity: 0.8,
            strokeWeight: 2,
            fillColor: '#FF0000',
            fillOpacity: 0.35,
            map: this.regionsMap,
            center: new google.maps.LatLng(llResult.Latitude, llResult.Longitude),
            radius: llResult.Radius * 1609.344
        };
        var thisCircleArrayInd = this.zipCirclesLayers.length;
        this.zipCirclesLayers[thisCircleArrayInd] = new google.maps.Circle(circleOpts);
        this.zipCirclesLayers[thisCircleArrayInd].setMap(this.regionsMap);

        var circleBounds = this.zipCirclesLayers[thisCircleArrayInd].getBounds();
        var topLeftBounds = new google.maps.LatLng(circleBounds.f.b, circleBounds.b.b);
        var botRightBounds = new google.maps.LatLng(circleBounds.f.f, circleBounds.b.f);

        this.regionsMapBounds.extend(topLeftBounds);
        this.regionsMapBounds.extend(botRightBounds);
        this.regionsMap.fitBounds(this.regionsMapBounds);
    },
    RefreshRegionSelections: function (type) {
        var existingRegionsArr = [];
        if (type == 'county') {
            for (var rco = 0; rco < this.regionsGrid.getRowsNum() ; rco++) {
                var thisCounty = this.regionsGrid.cells2(rco, 0).getValue(),
                    thisState = this.regionsGrid.cells2(rco, 1).getValue();
                if (thisCounty.length != 0 && thisState.toLowerCase() === this.stateInput.val().toLowerCase()) {
                    this.countyInput.find('option').each(function () {
                        if ($(this).text().toLowerCase() === thisCounty.toLowerCase())
                            $(this).remove();
                    });
                }
            }
        } else if (type == 'state') {
            this.stateInput.empty();
            this.stateInput.append('<option value="">Select...</option>');
            for (var rg = 0; rg < this.regionsGrid.getRowsNum() ; rg++) {
                if (this.regionsGrid.cells2(rg, 0).getValue() == 'All') {
                    existingRegionsArr.push(this.regionsGrid.cells2(rg, 1).getValue());
                }
            }
            var stArr = [];
            var thisCountry = jQuery('#addRegionCountry').val();
            if (thisCountry.toLowerCase() == 'us') {
                stArr = this.allStatesArr;
                //jQuery('#addRegionCityRow').hide();
                jQuery('#addRegionCountyRow').show();
            } else if (thisCountry.toLowerCase() == 'ca') {
                stArr = this.allProvinceArray;
                jQuery('#addRegionCountyRow').hide();
                //jQuery('#addRegionCityRow').show();
            }
            for (var rst = 0; rst < stArr.length; rst++) {
                var thisState = stArr[rst];
                if (existingRegionsArr.indexOf(thisState) == -1) {
                    this.stateInput.append('<option value="' + thisState + '">' + thisState + '</option>');
                }
            }
        }
    },
    GetPrequalRegionDropDownData: function () {
        var selectedCountry = jQuery('#addRegionCountry').val();
        var selectedCounty = jQuery('#addRegionCounty').val();
        var selectedState = jQuery('#addRegionState').val();
        if (jQuery('#addRegionCountry').is(':visible')) {
            if (selectedCountry.toLowerCase() == 'us') {
                jQuery('#contactStateCA').hide();
                jQuery('#contactStateUS').show();
            } else if (selectedCountry.toLowerCase() == 'ca') {
                jQuery('#contactStateUS').hide();
                jQuery('#contactStateCA').show();
            }
        }
        if (selectedState.length != 0) {
            jQuery('#addStateRegionsButton').button('enable');
        }
        if (selectedCountry != this.oldCountrySelect || selectedState != this.oldStateSelect || selectedCounty != this.oldCountySelect) {

            if (selectedState != this.oldStateSelect || selectedCounty == null) {
                selectedCounty = '';
            }
            PanteraScript.PanteraScriptService.GetPrequalRegionDropDownData(selectedCountry, selectedState, selectedCounty, this.GetPrequalRegionDropDownDataC.bind(this), onScriptError);
            this.oldCountrySelect = selectedCountry;
            this.oldStateSelect = selectedState;
            this.oldCountySelect = selectedCounty;
        } else {

        }

    },
    GetPrequalRegionDropDownDataC: function (response) {
        var ddResponse = jQuery.parseJSON(response);
        this.countyInput.empty();
        this.cityInput.empty();
        if (ddResponse.CountyList != null) {
            this.countyInput.append('<option value="">Select...</option>');
            for (var col = 0; col < ddResponse.CountyList.length; col++) {
                this.countyInput.append('<option value="' + ddResponse.CountyList[col] + '">' + ddResponse.CountyList[col] + '</option>');
            }
            this.countyInput.attr('disabled', false);
            this.countyInput.val(this.oldCountySelect);
        } else {
            this.countyInput.attr('disabled', true);
        }
        if (ddResponse.CityList != null) {
            this.cityInput.append('<option value="">Select...</option>');
            for (var cil = 0; cil < ddResponse.CityList.length; cil++) {
                this.cityInput.append('<option value="' + ddResponse.CityList[cil] + '">' + ddResponse.CityList[cil] + '</option>');
            }
            this.cityInput.attr('disabled', false);
        } else {
            this.cityInput.attr('disabled', true);
        }
        this.RefreshRegionSelections('county');
    },
    AddRegionHelper: function (type) {
        // if zip+radius, check for multiple states and show a dialog if > 1 states are included in the described radius.
        jQuery('#zipRadiusRegionError').empty();
        jQuery('#addRegionZip').removeClass('regionErrorElement');
        if (type == 'zip') {
            var zipVal = this.zipInput.val();
            var radiusVal = this.radiusInput.val();
            PanteraScript.PanteraScriptService.GetLatLongInfoByZipCode(zipVal, parseInt(radiusVal), this.AddRegionHelperC.bind(this), onScriptError);
        } else
            this.AddRegion(type);

        //this.AddRegion(type);
    },
    AddRegionHelperC: function (response) {
        var zipInfo = jQuery.parseJSON(response);
        // if zip+radius, check for multiple states and show a dialog if > 1 states are included in the described radius.
        if (zipInfo.StateProvinceCount > 1)
            this.InitZipStateCountryGrid(zipInfo);
        else
            this.AddRegion('zip');
    },
    AddRegion: function (type) {
        if (type == 'zip') {
            var thisRowId = 'newRow' + this.newRowCounter;
            var zipVal = this.zipInput.val();
            if (this.zipInput.val().length > 5) {
                zipVal = this.zipInput.val().replace(' ', '').replace('-', '');
                zipVal = zipVal.substring(0, 3) + ' ' + zipVal.substring(3, 6);
            }
            var radiusVal = this.radiusInput.val();
            var deleteButton = "<a href='#' onclick='DeleteRegion(\"newRow" + this.newRowCounter + "\");return false;'><img src='/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxToolbar/imgs/delete.png'></a>";
            var newRegionRowData = ['N/A', 'N/A', zipVal, this.radiusInput.val(), deleteButton];
            this.newRowCounter++;
            var regionSort = this.regionsGrid.getRowIndex(thisRowId);
            var thisZipRegion = [];
            thisZipRegion[0] = zipVal;
            thisZipRegion[1] = this.radiusInput.val();
            if (this.options.isSync) {
                var self = this;

                PanteraScript.PanteraScriptService.CheckZipExists(this.zipInput.val(), function (response) {
                    if (response) {
                        PanteraScript.PanteraScriptService.AddPrequalContactRegion(self.options.sessionId, self.options.contactId, thisRowId, regionSort, '', '', zipVal, radiusVal, self.AddRegionC.bind(self), onScriptError);

                        this.regionsGrid.addRow(thisRowId, newRegionRowData);
                        self.zipRegions.push(thisZipRegion);
                        self.CreateMapFusionLayersHelper();
                        self.UpdateRegionSelectUI(type);
                        if (typeof CalculateSectionCompletion == 'function')
                            CalculateSectionCompletion();
                    }
                    else {
                        jQuery('#zipRadiusRegionError').text("Invalid zip code");
                        jQuery('#addRegionZip').addClass('regionErrorElement');
                    }
                }, onScriptError);
            }
            else {
                this.regionsGrid.addRow(thisRowId, newRegionRowData);
                this.zipRegions.push(thisZipRegion);
                this.CreateMapFusionLayersHelper();
                this.UpdateRegionSelectUI(type);

                this.unsavedRegions.push({
                    contactId: this.options.contactId,
                    rowId: thisRowId,
                    sort: regionSort,
                    state: '',
                    county: '',
                    zip: zipVal,
                    radius: radiusVal
                });
            }
        } else if (type == 'state') {
            var thisRowId = 'newRow' + this.newRowCounter;
            var regionCountry = jQuery('#addRegionCountry').val();
            var regionCounty = '';
            if (regionCountry.toLowerCase() == 'us') {
                if (this.countyInput.val().length != 0) {
                    regionCounty = this.countyInput.val();
                } else {
                    regionCounty = 'All';
                }
            } else if (regionCountry.toLowerCase() == 'ca') {
                if (this.cityInput.val().length != 0) {
                    regionCounty = this.cityInput.val();
                } else {
                    regionCounty = 'All';
                }
            }
            var deleteButton = "<a href='#' onclick='DeleteRegion(\"newRow" + this.newRowCounter + "\");return false;'><img src='/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxToolbar/imgs/delete.png'></a>";
            var newRegionRowData = [regionCounty, this.stateInput.val(), 'All', 'N/A', deleteButton];
            this.regionsGrid.addRow(thisRowId, newRegionRowData);
            this.newRowCounter++;
            var regionSort = this.regionsGrid.getRowIndex(thisRowId);
            if (this.options.isSync)
                PanteraScript.PanteraScriptService.AddPrequalContactRegion(this.options.sessionId, this.options.contactId, thisRowId, regionSort, this.stateInput.val(), this.countyInput.val(), '', 0, this.AddRegionC.bind(this), onScriptError);
            else
                this.unsavedRegions.push({
                    contactId: this.options.contactId,
                    rowId: thisRowId,
                    sort: regionSort,
                    state: this.stateInput.val(),
                    county: this.countyInput.val(),
                    zip: '',
                    radius: 0
                });

            this.DeleteRegionsForNew(thisRowId);

            this.CreateMapFusionLayersHelper();
            this.UpdateRegionSelectUI(type);
            if (typeof CalculateSectionCompletion == 'function')
                CalculateSectionCompletion();
        } else if (type == 'allstates') {
            for (var as = 0; as < this.allStatesArr.length; as++) {
                if (this.stateInput.find('option:contains("' + this.allStatesArr[as] + '")').length != 0) {
                    var thisRowId = 'newRow' + this.newRowCounter;
                    var deleteButton = "<a href='#' onclick='DeleteRegion(\"newRow" + this.newRowCounter + "\");return false;'><img src='/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxToolbar/imgs/delete.png'></a>";
                    var newRegionRowData = ['All', this.allStatesArr[as], 'All', 'N/A', deleteButton];
                    this.regionsGrid.addRow(thisRowId, newRegionRowData);
                    var regionSort = this.regionsGrid.getRowIndex(thisRowId);
                    this.DeleteRegionsForNew(thisRowId);

                    this.newRowCounter++;
                }
            }
            if (this.options.isSync)
                PanteraScript.PanteraScriptService.AddPrequalContactRegionNationwide(this.options.sessionId, this.options.contactId, this.ReloadRegionsC.bind(this), onScriptError);

            this.CreateMapFusionLayersHelper();
            this.UpdateRegionSelectUI(type);
            if (typeof CalculateSectionCompletion == 'function')
                CalculateSectionCompletion();
        } else if (type == 'nationwide') {
            for (var as = 0; as < this.conusStatesArr.length; as++) {
                if (this.stateInput.find('option:contains("' + this.allStatesArr[as] + '")').length != 0) {
                    var thisRowId = 'newRow' + this.newRowCounter;
                    var deleteButton = "<a href='#' onclick='DeleteRegion(\"newRow" + this.newRowCounter + "\");return false;'><img src='/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxToolbar/imgs/delete.png'></a>";
                    var newRegionRowData = ['All', this.conusStatesArr[as], 'All', 'N/A', deleteButton];
                    this.regionsGrid.addRow(thisRowId, newRegionRowData);
                    var regionSort = this.regionsGrid.getRowIndex(thisRowId);
                    this.DeleteRegionsForNew(thisRowId);
                    this.newRowCounter++;
                }
            }

            if (this.options.isSync)
                PanteraScript.PanteraScriptService.AddPrequalContactRegionNationwide(this.options.sessionId, this.options.contactId, this.ReloadRegionsC.bind(this), onScriptError);
            else {
                this.unsavedRegions.push({
                    contactId: this.options.contactId,
                    rowId: 'nationwide',
                    sort: 0,
                    state: '',
                    county: '',
                    zip: '',
                    radius: 0
                });
            }
            this.CreateMapFusionLayersHelper();
            this.UpdateRegionSelectUI(type);
            if (typeof CalculateSectionCompletion == 'function')
                CalculateSectionCompletion();
        }

        jQuery('#regionsAddTable').removeClass('registerErrorElement');
        jQuery('#registerRegionsError').empty();
        this.onChange();
    },
    onChange: function () {
        if (typeof this.options.onChange === 'function')
            this.options.onChnage;
    },
    saveUnsavedRegions: function(){
        for (var i = 0 ; i < this.unsavedRegions.length ; i++) {
            if (this.unsavedRegions[i].rowId == 'nationwide') {
                PanteraScript.PanteraScriptService.AddPrequalContactRegionNationwide(this.options.sessionId, this.options.contactId, this.ReloadRegionsC.bind(this), onScriptError);
            }
            else {
                PanteraScript.PanteraScriptService.AddPrequalContactRegion(this.options.sessionId, this.unsavedRegions[i].contactId, this.unsavedRegions[i].rowId, this.unsavedRegions[i].sort, this.unsavedRegions[i].state, this.unsavedRegions[i].county, this.unsavedRegions[i].zip, this.unsavedRegions[i].radius, this.AddRegionC.bind(this), onScriptError);
            }
        }
        for (var i = 0 ; i < this.unsavedDeletedRegions.length ; i++) {
            PanteraScript.PanteraScriptService.DeletePrequalContactRegion(this.unsavedDeletedRegions[i], this.options.contactId, this.UpdateDeleteC.bind(this), onScriptError);
        }
    },
    ReloadRegionsC: function (response) {
        var gridXMLPath = "/DesktopModules/PJQRegistration/GetRegistrationGrid.aspx?sessionId=" + this.options.sessionId + "&contId=" + (this.options.contactId ? this.options.contactId.toString() : "") + "&gridId=Regions";
        if (this.options.gridXMLPath != null)
            gridXMLPath = this.options.gridXMLPath;
        this.regionsGrid.clearAll();
        this.regionsGrid.loadXML(gridXMLPath);
    },
    AddRegionC: function (response) {
        this.oldStateSelect = "";
        this.oldCountySelect = "";
        var arResult = jQuery.parseJSON(response);
        if (arResult.RegionId != 0) {
            var deleteButton = "<a href='#' onclick='DeleteRegion(\"" + arResult.RegionId + "\");return false;'><img src='/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxToolbar/imgs/delete.png'></a>";
            this.regionsGrid.setRowId(this.regionsGrid.getRowIndex(arResult.OldRowId), arResult.RegionId);
            this.regionsGrid.cells(arResult.RegionId, 4).setValue(deleteButton);
        } else
            this.regionsGrid.deleteRow(arResult.OldRowId);
    },
    DeleteRegionsForNew: function (regionId) {
        var deleteRegions = this.getDeleteRegions(regionId, false);
        this.DeleteRegionsWithCaching(deleteRegions);
    },
    DeleteRegion: function (regionId) {
        var deleteRegions = this.getDeleteRegions(regionId);
        this.DeleteRegionsWithCaching(deleteRegions);
        this.onChange();
    },
    DeleteAllRegions: function () {
        if (this.options.isSync)
            PanteraScript.PanteraScriptService.DeleteAllPrequalContactRegions(this.options.contactId, this.UpdateDeleteC.bind(this), onScriptError);
        else {
            var deleteRegions = [];
            for (var i = 0 ; i < this.regionsGrid.getRowsNum() ; i++) {
                deleteRegions.push(this.regionsGrid.getRowId(i));
            }
            this.DeleteRegionsWithCaching(deleteRegions);
        }
        this.regionsGrid.clearAll();
        this.CreateMapFusionLayersHelper();
        this.RefreshRegionSelections('state');
        this.onChange();
    },
    onChange: function () {
        if (typeof this.options.onChange === 'function')
            this.options.onChange();
    },
    DeleteRegionsWithCaching: function(deleteRegions){
        if (deleteRegions.length > 0) {
            for (var i = 0 ; i < deleteRegions.length ; i++) {
                this.regionsGrid.deleteRow(deleteRegions[i]);

                if (this.options.isSync)
                    PanteraScript.PanteraScriptService.DeletePrequalContactRegion(deleteRegions[i], this.options.contactId, this.UpdateDeleteC.bind(this), onScriptError);
                else if (_.find(this.unsavedRegions, function (region) { return region.rowId == deleteRegions[i] }) != null)
                    this.unsavedRegions = _.filter(this.unsavedRegions, function (region) { return deleteRegions[i] != region.rowId });
                else
                    this.unsavedDeletedRegions.push(deleteRegions[i]);
            }
            this.CreateMapFusionLayersHelper();
            this.RefreshRegionSelections('state');

            if (typeof CalculateSectionCompletion == 'function')
                CalculateSectionCompletion();
        }
    },
    getDeleteRegions: function (id, isIncludeSelf) {
        if (isIncludeSelf == null)
            isIncludeSelf = true;

        var thisCounty = this.regionsGrid.cells(id, 0).getValue(),
            thisState = this.regionsGrid.cells(id, 1).getValue(),
            thisZip = this.regionsGrid.cells(id, 2).getValue(),
            thisRadius = this.regionsGrid.cells(id, 3).getValue(),
            deleteRegions = [];

        if ((thisCounty.length == 0 || thisCounty.toLowerCase() == 'all') && (thisZip.length == 0 || thisZip.toLowerCase() == 'all')) {
            for (var i = 0 ; i < this.regionsGrid.getRowsNum() ; i++) {
                if (this.regionsGrid.cells2(i, 1).getValue() == thisState && (this.regionsGrid.getRowId(i) != id || isIncludeSelf) && this.regionsGrid.cells2(i, 0).getValue().toLowerCase() != 'all' && this.regionsGrid.cells2(i, 0).getValue() != '')
                    deleteRegions.push(this.regionsGrid.getRowId(i));
            }
        }
        if (isIncludeSelf && deleteRegions.indexOf(id) == -1)
            deleteRegions.push(id);

        return deleteRegions;
    },
    AddNationwideRegions: function() {
        this.regionsGrid.clearAll();
        if (this.options.isSync)
            PanteraScript.PanteraScriptService.DeleteAllPrequalContactRegions(this.options.contactId, this.AddNationwideRegionsC.bind(this), onScriptError);
        else
            this.AddRegion('nationwide');
    },
    AddNationwideRegionsC: function()  {
        this.AddRegion('nationwide');
    },
    UpdateDeleteC: function (response) {

    },
    UpdateRegionSelectUI: function (type) {
        if (type == 'zip') {
            this.zipInput.val('');
            this.radiusInput.val(50);
            this.zipInput.trigger('change');
            jQuery('#addZipRegionsButton').button('disable');
        } else if (type == 'state') {
            this.RefreshRegionSelections('state');
            this.stateInput.val('');
            this.countyInput.val('');
            this.cityInput.val('');
            this.countyInput.empty();
            this.cityInput.empty();
            this.cityInput.append('<option value="">Select...</option>');
            this.countyInput.append('<option value="">Select...</option>');
            this.countyInput.attr('disabled', true);
            this.cityInput.attr('disabled', true);
            jQuery('#addStateRegionsButton').button('disable');
        } else if (type == 'allstates') {
            this.RefreshRegionSelections('state');
            this.stateInput.val('');
            this.countyInput.val('');
            this.cityInput.val('');
            this.countyInput.empty();
            this.cityInput.empty();
            this.cityInput.append('<option value="">Select...</option>');
            this.countyInput.append('<option value="">Select...</option>');
            this.stateInput.attr('disabled', true);
            this.countyInput.attr('disabled', true);
            this.cityInput.attr('disabled', true);
            jQuery('#addStateRegionsButton').button('disable');
        }
    },
    InitZipStateCountryGrid: function (zipInfo) {
        if (this.zipStateCountyGrid == null) {
            this.zipStateCountyGrid = new dhtmlXGridObject('grid-zip-state-counties');
            this.zipStateCountyGrid.setImagePath('/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxgrid/imgs/');
            this.zipStateCountyGrid.setSkin(pjqGridTheme);
            this.zipStateCountyGrid.enableAutoHeight(true, 400);
            this.zipStateCountyGrid.setHeader("#master_checkbox,State,County");
            this.zipStateCountyGrid.setInitWidthsP("6,15,74");
            this.zipStateCountyGrid.setColAlign("center,center,left");
            this.zipStateCountyGrid.setColTypes("ch,ro,ro");
            this.zipStateCountyGrid.setColSorting("na,na,na");
            this.zipStateCountyGrid.enableTooltips("false,false,true");
            this.zipStateCountyGrid.init();
        } else
            this.zipStateCountyGrid.clearAll();

        for (var i = 0; i < zipInfo.ZipInfoList.length; i++) {
            this.zipStateCountyGrid.addRow(i.toString(), '0,' + zipInfo.ZipInfoList[i].State + ',' + zipInfo.ZipInfoList[i].County);
        }

        var self = this;
        this.zipStateCountyDlg = jQuery('#zipRadiusCountyListDialog').dialog({
            title: "Select States/Counties",
            modal: true,
            resizable: false,
            width: 400,
            buttons: {
                OK: function () {
                    self.zipStateCountyCheckedCount = 0;
                    self.zipStateCountyGrid.forEachRow(function (id) {
                        if (self.zipStateCountyGrid.cells(id, 0).isChecked()) {
                            self.zipStateCountyCheckedCount++;

                            // only add to regions grid if this state/country aren't already there.
                            self.zipStateCountyFound = false;
                            self.regionsGrid.forEachRow(function (id2) {
                                if (self.zipStateCountyGrid.cells(id, 1).getValue() == self.regionsGrid.cells(id2, 1) && self.zipStateCountyGrid.cells(id, 2).getValue() == self.regionsGrid.cells(id2, 0)) {
                                    self.zipStateCountyFound = true;
                                }
                            });
                            if (!self.zipStateCountyFound) {
                                // do the add region stuff.
                                var thisRowId = 'newRow' + self.newRowCounter;
                                var regionCountry = 'US';
                                var regionCounty = self.zipStateCountyGrid.cells(id, 2).getValue();
                                var regionState = self.zipStateCountyGrid.cells(id, 1).getValue();
                                var deleteButton = "<a href='#' onclick='DeleteRegion(\"newRow" + self.newRowCounter + "\");return false;'><img src='/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxToolbar/imgs/delete.png'></a>";
                                var newRegionRowData = [regionCounty, regionState, 'All', 'N/A', deleteButton];
                                self.regionsGrid.addRow(thisRowId, newRegionRowData);
                                self.newRowCounter++;
                                var regionSort = self.regionsGrid.getRowIndex(thisRowId);

                                if (self.options.isSync)
                                    PanteraScript.PanteraScriptService.AddPrequalContactRegion(self.options.sessionId, self.options.contactId, thisRowId, regionSort, regionState, regionCounty, '', 0, self.AddRegionC.bind(self), onScriptError);
                                else {
                                    self.unsavedRegions.push({
                                        contactId: self.options.contactId,
                                        rowId: thisRowId,
                                        sort: regionSort,
                                        state: regionState,
                                        county: regionCounty,
                                        zip: '',
                                        radius: 0
                                    });
                                }

                            }

                        }
                    });
                    if (self.zipStateCountyCheckedCount == 0)
                        return;

                    self.CreateMapFusionLayersHelper();
                    self.UpdateRegionSelectUI('zip');
                    jQuery('#regionsAddTable').removeClass('registerErrorElement');
                    jQuery('#registerRegionsError').empty();
                    self.zipStateCountyDlg.dialog('close');
                    self.onChange();
                },
                Cancel: function () {
                    self.zipStateCountyDlg.dialog('close');
                }
            }
        });
    }
};



